<template>
  <div class="inbox_box">
      <div class="innerLeft" @click="backHandle">
        <i class="el-icon-arrow-left"></i>Back
      </div>
    <div class="tabel" v-loading="inboxLoading">
      <el-table v-if="inboxData.length != 0" :data="inboxData" style="width: 100%; font-weight: normal">
        <el-table-column prop="business_name" label="Business Name (Short)" class-name="changePadding"></el-table-column>
        <el-table-column prop="legal_company_name" label="Legal Company Name"></el-table-column>
        <el-table-column prop="organization_number" label="Organization ID"></el-table-column>
        <el-table-column prop="time" label="Submitted Time"></el-table-column>
        <el-table-column prop="status" label="Status" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0" class="status_box yellow_2">Pending</div>
            <div v-if="scope.row.status == 2" class="status_box red">Refused</div>
            <div v-if="scope.row.status == 1" class="status_box green">Approved</div>
          </template>
        </el-table-column>
        <el-table-column label="Actions" width="100px"  align="center">
          <template slot-scope="scope">
            <div class="action">
              <span @click="handleProfile(scope.$index, scope.row)"  v-if="scope.row.status == 0" >
                <img src="../assets/billing/process@2x.png" style="width: 16px" alt=""/>
              </span>
              <span v-else>
              <img src="../assets/billing/slice.png" style="width: 16px" alt=""/>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div v-else class="empty">
        <div>
          <img src="../assets/image/list_blank.png" alt=""/>
          <h2 style="color: #cccccc; font-size: 16px">No items found</h2>
        </div>
      </div>
      <div class="btomPagin">
        <div class="innerLeft">
          {{ currentPage }} - <span>{{ inboxData.length }}</span> of
          <span>{{ pageTotal }}</span> items
        </div>
        <div>
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="10" layout="prev, pager, next, jumper" :current-page="currentPage" :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :visible.sync="comProfileDiog"
    >
      <comProfire @closeProfire="closeProfireHandle"
                  :profileDetial="profileDetial"
                  @openReject="rejectDialog = true"
      ></comProfire>
    </el-dialog>
        <!--    拒绝弹框-->
        <el-dialog
          style="padding-top: 0"
          title="Refuse application"
          :visible.sync="rejectDialog"
          width="35%">
            <div>
              <div style="margin: 16px 0">Notes</div>
              <div>
                <el-input v-model="rejectNote" placeholder="Input some reasons." type="textarea" :rows="4"></el-input>
              </div>
            </div>
          <span slot="footer" class="dialog-footer">
             <el-button type="danger" @click="rejectDialog = false" plain>Cancel</el-button>
        <el-button type="primary" @click="rejectHandle" round>Save</el-button>
      </span>
        </el-dialog>
  </div>
</template>

<script>
import comProfire from "@/components/comProfire";
import {getInboxList, rejectInvite} from "@/api/inbox";
export default {
  name: "inbox",
  components:{
    comProfire
  },
  data(){
    return{
      rejectNote:'',
      rejectDialog:false,
      profileDetial:{},
      comProfileDiog:false,
      inboxLoading:false,
      currentPage:1,
      pageTotal:0,
      inboxData:[],
    }
  },
  created() {
    this.getInboxHandle()
  },
  methods:{
    handleCurrentChange(val){
      this.currentPage =val
      this.getInboxHandle()
    },
    closeProfireHandle(){
      this.comProfileDiog =false
      this.getInboxHandle()
    },
    //拒绝申请
    rejectHandle(){
      rejectInvite({
        id:this.profileDetial.id,
        remark:this.rejectNote
      }).then(res=>{
        if (res.code == 200){
          this.rejectDialog = false
          this.comProfileDiog =false
          this.getInboxHandle()
          this.$message({
            type:'success',
            message:'You have refused the organization application'
          })
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:'error',
          message:err.msg
        })
      })
    },
    getInboxHandle(){
      this.inboxLoading = true
      getInboxList({
        page:this.currentPage,
        limit:10
      }).then(res=>{
        this.inboxLoading = false
        if (res.code == 200){
          this.inboxData = res.data.data
          this.inboxData.forEach(v=>{
            v.time = this.formatDate(v.time)
          })
          this.pageTotal = res.data.count
        }
      })
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000); // 将秒转换为毫秒
      const options = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      };
      return date.toLocaleString('en-US', options);
    },
    backHandle(){
      this.$emit('back')
    },
    handleProfile(v,n){
      this.profileDetial = n
      this.comProfileDiog = true
    }
  }
}
</script>

<style scoped lang="less">
/deep/.changePadding{
  padding-left: 48px;
}
.inbox_box{
  width: 100%;

  .innerLeft{
    text-align: left;
    margin-bottom: 22px;
  }
  .status_box {
    border-radius: 11px;
    width: 103px;
    font-weight: bold;
    font-size: 13px;
    color: #FFFFFF;
    text-align: center;
    margin: 0 auto;
  }

  .red {
    background-color: #E95646;
  }

  .yellow_2 {
    background-color: #FFC215;
  }

  .green {
    background-color: #82D237;
  }
  .empty{
    text-align: center;
  }
  .btomPagin {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;

    .innerLeft {
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1f2d42;
      line-height: 20px;
    }
  }

}

</style>
